import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getCharges,
    getAdjustments,
    getAdjustmentsReport,
    getCustomAdjustments,
    getCustomAdjustmentsReport,
    getMargins,
    getMarginsReport,
    getVerifiedMargins,
    getVerifiedMarginsReport,
} from '../../helpers';
import {
    financialsKpisApiResponseSuccess,
    financialsKpisApiResponseError,
} from './actions';
import { FinancialsKpisActionTypes } from './constants';
import { addToast } from '../actions';
import { paginationHeadersResponse } from '../../helpers/mappers/pagination';

export function* getChargesSaga({ payload: { query } }) {
    try {
        const response = yield call(getCharges, query);
        const charges = response.data;
        const pagination = { ...paginationHeadersResponse(response.headers), ...query };
        yield put(financialsKpisApiResponseSuccess(FinancialsKpisActionTypes.GET_CHARGES, { charges, pagination }));
    } catch (error) {
        yield put(financialsKpisApiResponseError(FinancialsKpisActionTypes.GET_CHARGES, error));
    }
}

export function* getAdjustmentsSaga({ payload: { query } }) {
    try {
        const response = yield call(getAdjustments, query);
        const adjustments = response.data;
        const pagination = { ...paginationHeadersResponse(response.headers), ...query };
        yield put(financialsKpisApiResponseSuccess(FinancialsKpisActionTypes.GET_ADJUSTMENTS, { adjustments, pagination }));
    } catch (error) {
        yield put(financialsKpisApiResponseError(FinancialsKpisActionTypes.GET_ADJUSTMENTS, error));
    }
}

export function* getAdjustmentsReportSaga({ payload: { query } }) {
    try {
        const response = yield call(getAdjustmentsReport, query);
        const adjustmentsReport = response.data;
        yield put(financialsKpisApiResponseSuccess(FinancialsKpisActionTypes.GET_ADJUSTMENTS_REPORT, { adjustmentsReport }));
    } catch (error) {
        yield put(financialsKpisApiResponseError(FinancialsKpisActionTypes.GET_ADJUSTMENTS_REPORT, error));
    }
}

export function* getCustomAdjustmentsSaga({ payload: { query } }) {
    try {
        const response = yield call(getCustomAdjustments, query);
        const customAdjustments = response.data;
        const pagination = { ...paginationHeadersResponse(response.headers), ...query };
        yield put(financialsKpisApiResponseSuccess(FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS, { customAdjustments, pagination }));
    } catch (error) {
        yield put(financialsKpisApiResponseError(FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS, error));
    }
}

export function* getCustomAdjustmentsReportSaga({ payload: { query } }) {
    try {
        const response = yield call(getCustomAdjustmentsReport, query);
        const customAdjustmentsReport = response.data;
        yield put(financialsKpisApiResponseSuccess(FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS_REPORT, { customAdjustmentsReport }));
    } catch (error) {
        yield put(financialsKpisApiResponseError(FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS_REPORT, error));
    }
}

export function* getMarginsSaga({ payload: { query } }) {
    try {
        const response = yield call(getMargins, query);
        const margins = response.data;
        const pagination = { ...paginationHeadersResponse(response.headers), ...query };
        yield put(financialsKpisApiResponseSuccess(FinancialsKpisActionTypes.GET_MARGINS, { margins, pagination }));
    } catch (error) {
        yield put(financialsKpisApiResponseError(FinancialsKpisActionTypes.GET_MARGINS, error));
    }
}

export function* getMarginsReportSaga({ payload: { query } }) {
    try {
        const response = yield call(getMarginsReport, query);
        const marginsReport = response.data;
        yield put(financialsKpisApiResponseSuccess(FinancialsKpisActionTypes.GET_MARGINS_REPORT, { marginsReport }));
    } catch (error) {
        yield put(financialsKpisApiResponseError(FinancialsKpisActionTypes.GET_MARGINS_REPORT, error));
    }
}

export function* getVerifiedMarginsSaga({ payload: { query } }) {
    try {
        const response = yield call(getVerifiedMargins, query);
        const verifiedMargins = response.data;
        const pagination = { ...paginationHeadersResponse(response.headers), ...query };
        yield put(financialsKpisApiResponseSuccess(FinancialsKpisActionTypes.GET_VERIFIED_MARGINS, { verifiedMargins, pagination }));
    } catch (error) {
        yield put(financialsKpisApiResponseError(FinancialsKpisActionTypes.GET_VERIFIED_MARGINS, error));
    }
}

export function* getVerifiedMarginsReportSaga({ payload: { query } }) {
    try {
        const response = yield call(getVerifiedMarginsReport, query);
        const verifiedMarginsReport = response.data;
        yield put(financialsKpisApiResponseSuccess(FinancialsKpisActionTypes.GET_VERIFIED_MARGINS_REPORT, { verifiedMarginsReport }));
    } catch (error) {
        yield put(financialsKpisApiResponseError(FinancialsKpisActionTypes.GET_VERIFIED_MARGINS_REPORT, error));
    }
}

export function* watchGetChargesSaga(): any {
    yield takeLatest(FinancialsKpisActionTypes.GET_CHARGES, getChargesSaga);
}

export function* watchGetAdjustmentsSaga(): any {
    yield takeLatest(FinancialsKpisActionTypes.GET_ADJUSTMENTS, getAdjustmentsSaga);
}

export function* watchGetAdjustmentsReportSaga(): any {
    yield takeLatest(FinancialsKpisActionTypes.GET_ADJUSTMENTS_REPORT, getAdjustmentsReportSaga);
}

export function* watchGetCustomAdjustmentsSaga(): any {
    yield takeLatest(FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS, getCustomAdjustmentsSaga);
}

export function* watchGetCustomAdjustmentsReportSaga(): any {
    yield takeLatest(FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS_REPORT, getCustomAdjustmentsReportSaga);
}

export function* watchGetMarginsSaga(): any {
    yield takeLatest(FinancialsKpisActionTypes.GET_MARGINS, getMarginsSaga);
}

export function* watchGetMarginsReportSaga(): any {
    yield takeLatest(FinancialsKpisActionTypes.GET_MARGINS_REPORT, getMarginsReportSaga);
}

export function* watchGetVerifiedMarginsSaga(): any {
    yield takeLatest(FinancialsKpisActionTypes.GET_VERIFIED_MARGINS, getVerifiedMarginsSaga);
}

export function* watchGetVerifiedMarginsReportSaga(): any {
    yield takeLatest(FinancialsKpisActionTypes.GET_VERIFIED_MARGINS_REPORT, getVerifiedMarginsReportSaga);
}

function* financialsKpisSaga() {
    yield all([
        fork(watchGetChargesSaga),
        fork(watchGetAdjustmentsSaga),
        fork(watchGetAdjustmentsReportSaga),
        fork(watchGetCustomAdjustmentsSaga),
        fork(watchGetCustomAdjustmentsReportSaga),
        fork(watchGetMarginsSaga),
        fork(watchGetMarginsReportSaga),
        fork(watchGetVerifiedMarginsSaga),
        fork(watchGetVerifiedMarginsReportSaga),
    ]);
}

export default financialsKpisSaga;
